import { render, staticRenderFns } from "./AssignmentsItem.vue?vue&type=template&id=76f790a8&scoped=true&"
import script from "./AssignmentsItem.vue?vue&type=script&lang=js&"
export * from "./AssignmentsItem.vue?vue&type=script&lang=js&"
import style0 from "./AssignmentsItem.vue?vue&type=style&index=0&id=76f790a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76f790a8",
  null
  
)

export default component.exports